import Swal from "sweetalert2";
import api from "../../../utilities/interseptor";

const key = process.env.REACT_APP_CLAVE_INCRIPTACION;
const apiUrl = process.env.REACT_APP_API

export const getIndicadores = (data, setIndicadores) => {

    api.get(apiUrl + `/monitor/indicadores?fecha_inicio=${data.fecha_inicio}&fecha_fin=${data.fecha_fin}`).then((res) => {
        setIndicadores(res.data)

    })
        .catch((error) => {
            console.log("error", error);

        })
}

export const getClients = (setClients,zonas=null) => {
    let zonasFormateadas = ""
    if(zonas)
    {
        zonas?.map((item,key) => {
            if(key == zonas.length)
            {
                zonasFormateadas = zonasFormateadas + item.code
            }
            else if(key == 0)
            {
                zonasFormateadas =  zonasFormateadas + item.code 
            }
            else
            {
                zonasFormateadas =  zonasFormateadas + " ," + item.code 
            }
        })
    }else{
        zonasFormateadas=null
    }
    
    api.get(apiUrl + `/monitor/getAllClients?zonas=${zonasFormateadas}`).then((res) => {
        setClients(res.data)

    })
        .catch((error) => {
            console.log("error", error);

        })

}
export const getZonas = (setZonas) => {
    api.get(apiUrl + `/monitor/tablero/areas`).then((res) => {
        setZonas(res.data)

    })
        .catch((error) => {
            console.log("error", error);

        })

}
export const getTables = (params, setTables) => {


    api.get(apiUrl + `/monitor/indicadoresTablas?fecha_inicio=${params.fecha_inicio}&fecha_fin=${params.fecha_fin}&tipo=${params.tipo}&proveedor=${params.proveedor}&cliente=${params.cliente}&rango10m=${params.rango10m}`).then((res) => {
        setTables(res.data)

    })
        .catch((error) => {
            console.log("error", error);

        })

}
export const mandarMensaje = (telefono, mensaje) => {

    const data = {
        "phone": "521"+telefono,
        "content": mensaje
    }

    api.post(`https://apiwa.sumaenlinea.mx/messages/sendMessage`,data).then((res) => {
        Swal.fire({
            icon: 'success',   // Icono de error
            title: 'Mensaje mandado con exito', // Título de la alerta
          });

    })
        .catch((error) => {
            Swal.fire({
                icon: 'error',   // Icono de error
                text: 'No se a mandado el mensaje por favor contactar a I+D', // Mensaje de error
                confirmButtonText: 'OK'  // Texto del botón de confirmación
              });

        })

}